var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({}) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form", name: "editNumber", novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("Field", {
                  attrs: {
                    label: _vm.$t("NUMBERS_NAME"),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t("NUMBERS_NAME_TT")
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "element",
                        fn: function() {
                          return [
                            _c("ValidationProvider", {
                              ref: "name",
                              attrs: { rules: "", slim: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ classes }) {
                                      return [
                                        _c("div", { class: classes }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-4 col-md-3"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.inputs.name,
                                                    expression: "inputs.name"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  name: "name",
                                                  autocomplete: "off",
                                                  "data-testid":
                                                    "number-name-input"
                                                },
                                                domProps: {
                                                  value: _vm.inputs.name
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.inputs,
                                                      "name",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("Field", {
                  attrs: {
                    label: _vm.$t("NUMBERS_TAGS"),
                    "has-tooltip": true,
                    "tooltip-text": _vm.$t("NUMBERS_TAGS_TT")
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "element",
                        fn: function() {
                          return [
                            _c("ValidationProvider", {
                              ref: "tagRef",
                              attrs: { rules: "", slim: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ classes }) {
                                      return [
                                        _c("div", { class: classes }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-4 col-md-3"
                                            },
                                            [
                                              _c("TagInput", {
                                                model: {
                                                  value: _vm.inputs.tags,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.inputs,
                                                      "tags",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "inputs.tags"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row m-b-10" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-7 col-md-7 col-sm-offset-3" },
                    [
                      _c(
                        "PrimaryButton",
                        {
                          attrs: {
                            size: "sm",
                            type: "submit",
                            "show-loader-on-form": _vm.submitting,
                            "data-testid": "number-save-btn"
                          },
                          on: { click: _vm.onSubmit }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("SAVE")) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger btn-sm m-l-15",
                          attrs: {
                            type: "button",
                            "ng-if": "!vm.isNumberPool && !vm.currentCampaign"
                          },
                          on: { click: _vm.onCancel }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("CANCEL")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }